export default __webpack_public_path__ + "static/media/BentonSans-Medium.7923b7db.otf";